import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { SUBSCRIBER_TEST_IDS } from '../../../../brands/default/constants';

export const Input = ({ onFocus, onBlur, onChange }) => {
  const inputClassNames = classNames(`form-control field__email ng-valid`);

  return (
    <input
      className={inputClassNames}
      data-qa="enterEmail"
      data-testid={SUBSCRIBER_TEST_IDS.EMAIL_INPUT}
      name="email"
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      placeholder="Enter your email address"
      required
      type="text"
    />
  );
};

Input.propTypes = {
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
};
